import React, { useState } from "react";
import { Col, Row } from "reactstrap";
import ProfileMail from "./ProfileMail";
import ProfileContact from "./ProfileContact";
import { Link } from "react-router-dom";
import "./ProfileDetail.scss";
import EditCompanyModal from "../EditCompanyModal";

interface ProfileDetailProps {
    profile: any;
}

const ProfileDetail: React.FC<ProfileDetailProps> = ({ profile }) => {
    const [editModalOpen, setEditModalOpen] = useState(false);

    const toggleEditModal = () => {
        setEditModalOpen(!editModalOpen);
    };

    return (
        <>
            <div className="info">
                <Row className="g-3 step3">
                    <ProfileMail email={profile?.user?.email || "N/A"} bod={"02 January 1988"} />
                    <Col sm={12} lg={4} className="order-sm-0 order-xl-1">
                        <div className="user-designation tour-email">
                            <div className="title" style={{ fontSize: "40px", fontWeight: "bold",textTransform: "uppercase"  }}>
                                <span>{profile?.name || "Unknown User"}</span>
                            </div>

                            <div className="dept">
                                <span>{profile?.Department?.departmentname || "Travancore Medicity Staff "}</span>
                            </div>

                        </div>
                    </Col>
                    <ProfileContact contact={profile?.contactno || profile?.contactdetails} location={"Beverly Hills"} />
                </Row>
                <hr />

                {/* Show Company Section only for Medical Rep (usertype === 1) */}
                {profile?.user?.usertype === 1 && (
                    <>
                        <div className="company-details" style={{ marginTop: "10px", padding: "0 20px" }}>
                            <h4 style={{ marginBottom: "10px" }}>Company Information</h4>
                            <button className="btn btn-primary" onClick={toggleEditModal}>Edit</button>

                            <div className="company-info">
                                <div className="info-row"><strong>Name:</strong> {profile?.Company?.companyname || "N/A"}</div>
                                <div className="info-row"><strong>DL No:</strong> {profile?.Company?.licenseno || "N/A"}</div>
                                <div className="info-row"><strong>Address:</strong> {profile?.Company?.companyaddress || "N/A"}</div>
                                <div className="info-row"><strong>Contact:</strong> {profile?.Company?.contactno || "N/A"}</div>
                                <div className="info-row"><strong>Email:</strong> {profile?.Company?.companyemail || "N/A"}</div>
                            </div>
                        </div>
                        <hr />

                        {/* Edit Company Modal */}
                        <EditCompanyModal isOpen={editModalOpen} toggle={toggleEditModal} profile={profile} />
                    </>
                )}
            </div>
        </>
    );
};

export default ProfileDetail;
